import LinkInlineArrowShort from './LinkInlineArrowShort'

export default LinkInlineArrowShort
